var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.query.user_type === 'Individual')?_c('individual'):(_vm.$route.query.user_type === 'Business')?_c('Bussiness'):_vm._e(),_c('OverlayPageVue',{attrs:{"showOverlay":_vm.loader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }